<template>
  <div class="PageVenueAppointmentDetail m-hp-100 m-fb-col m-hidden m-fb-cross-center">
    <CommonHeader :title="type == 2 ? '我收到的邀约' : type == 3 ? '我收到的审批' : '我发起的预约'"></CommonHeader>
    <CommonBox class="m-item-flex-1 m-hp-100 m-fb m-hidden m-fb-col" v-if="isInitDoneFlag">
      <div class="m-auto m-wp-100 m-p-24-0 m-p-0-32 detail-box m-item-flex-1">
        <p class="m-font-18 m-bold m-w-168 m-pointer" @click="handlerGoBack">
          <i class="m-icon m-icon-arrow-left m-mr-12 m-font-18"></i>{{ type == 3 ? '审批详情' : '预约详情' }}</p
        >
        <img :src="computedStatusType[appointmentDetail.status]" alt="" class="status-img" />
        <div class="m-p-0-24">
          <div class="m-c-999999 m-m-24-0 m-fb m-fb-cross-center">
            <span class="m-mr-16">预约人信息</span> <span class="line m-item-flex-1"></span
          ></div>
          <div class="m-ml-150" v-if="appointmentDetail.reserverInfoDto">
            <p class="item">
              <span>预约人</span>{{ appointmentDetail.reserverInfoDto.userName }}
              <span v-if="appointmentDetail.reserverInfoDto.memberJobNum"
                >（{{ appointmentDetail.reserverInfoDto.memberJobNum }}）</span
              >
            </p>
            <p class="item" v-if="appointmentDetail.reserverInfoDto.userDeptName">
              <span>预约人单位</span>{{ appointmentDetail.reserverInfoDto.userDeptName }}
            </p>
            <p class="item" v-if="appointmentDetail.reserverInfoDto.email">
              <span>邮箱</span>{{ appointmentDetail.reserverInfoDto.email }}
            </p>
            <p class="item" v-if="appointmentDetail.reserverInfoDto.phone">
              <span>联系方式</span>{{ appointmentDetail.reserverInfoDto.phone }}
            </p>
          </div>
          <div class="m-c-999999 m-m-24-0 m-fb m-fb-cross-center">
            <span class="m-mr-16">预约信息</span> <span class="line m-item-flex-1"></span
          ></div>
          <div class="m-ml-150">
            <p class="item"> <span>预约时间</span>{{ appointmentDetail.reserveTime }} </p>
            <p class="item m-newline">
              <span>预约地点</span>{{ appointmentDetail.resourcePosition }}
              <span
                class="m-c-theme m-ml-8 m-pointer m-item-shrink-0"
                @click="handlerToDetail"
                v-if="appointmentDetail.resourceAuthority"
                >查看详情</span
              >
            </p>
            <p class="item"> <span>活动类型</span>{{ appointmentDetail.reserveType }} </p>
            <p class="item"> <span>活动名称</span>{{ appointmentDetail.activityName }} </p>
            <p class="item" v-if="computedMemberName"> <span>参与人</span>{{ computedMemberName }} </p>
            <p class="item" v-if="appointmentDetail.memo && uni !== 'zheda'">
              <span>备注</span> <span class="m-wrap">{{ appointmentDetail.memo }} </span></p
            >
            <p class="item" v-if="uni !== 'zheda' && appointmentDetail.enclosure && appointmentDetail.enclosure.picUrl">
              <span>附件</span
              ><span lass="m-fb m-item-flex-1"
                ><span class="m-wrap"
                  >{{ appointmentDetail.enclosure.fileName }}
                  <MButton class="m-ml-24" @click="handlerDownloadenClosure(appointmentDetail.enclosure)"
                    >下载</MButton
                  ></span
                >
              </span>
            </p>
          </div>
          <template v-if="uniShowSingleApproval && appointmentDetail.auditInfoDto && [1, 3].includes(+type)">
            <div class="m-c-999999 m-m-24-0 m-fb m-fb-cross-center">
              <span class="m-mr-16">审批流程</span> <span class="line m-item-flex-1"></span
            ></div>
            <div class="m-ml-275">
              <MSteps position="center">
                <MStep class="m-h-44 m-lh-44" :ready="true">
                  <div class="m-fb">
                    <p class="m-w-300 m-fb">
                      <span class="name text-ellipsis">{{ isMe(appointmentDetail.auditInfoDto) }}</span>
                      <span class="m-ml-8 m-c-999999">发起审批</span></p
                    >
                    <p class="m-c-999999">{{
                      timeFormatNew(appointmentDetail.auditInfoDto.gmtCreate, 'YYYY-MM-DD hh:mm:ss')
                    }}</p>
                  </div>
                </MStep>
                <template v-if="appointmentDetail.auditInfoDto && appointmentDetail.auditInfoDto.jobNodeMemberDtoList">
                  <template v-for="(item, index) in appointmentDetail.auditInfoDto.jobNodeMemberDtoList">
                    <!-- 撤销和拒绝的时候，审批中和未轮到都不显示 -->
                    <MStep
                      class="m-h-44 m-lh-44"
                      :ready="!!item.status"
                      v-if="!([4, 2].includes(appointmentDetail.auditInfoDto.status) && [0, 1].includes(item.status))"
                      :key="index"
                    >
                      <div class="m-fb">
                        <p class="m-w-300 m-fb"
                          ><span class="name text-ellipsis">{{ isMe(item) }}</span>
                          <template v-if="item.status">
                            <span class="m-ml-8" :class="APPROVAL_AUDIT_MAP[item.status].class">{{
                              APPROVAL_AUDIT_MAP[item.status].text
                            }}</span>
                          </template>
                        </p>
                        <p class="m-c-999999" v-if="item.status && item.status !== 1">{{
                          timeFormatNew(item.gmtModify, 'YYYY-MM-DD hh:mm:ss')
                        }}</p>
                      </div>
                    </MStep>
                  </template>
                </template>
                <MStep class="m-h-64 m-lh-64" :ready="true" v-if="appointmentDetail.auditInfoDto.status === 4">
                  <div class="m-fb">
                    <p class="m-w-300 m-fb">
                      <span class="name text-ellipsis">{{ isMe(appointmentDetail.auditInfoDto, 2) }}</span>
                      <span class="m-ml-8 m-c-999999">撤销审批</span></p
                    >
                    <p class="m-c-999999">{{
                      timeFormatNew(appointmentDetail.auditInfoDto.gmtModify, 'YYYY-MM-DD hh:mm:ss')
                    }}</p>
                  </div>
                </MStep>
              </MSteps>
            </div>
          </template>
        </div>
      </div>
      <div class="footer m-fb-center-center" v-if="computedShowCancel || computedShowGolz">
        <!-- <MButton v-if="computedShowGolz" type="primary" :simple="true" class="m-mr-16" @click="handlerGoLvzhi()"
          >前往智慧办公平台</MButton
        > -->
        <MButton v-if="computedShowTONotice" type="primary" :simple="true" class="m-mr-16" @click="handlerGoLvzhi()"
          >会议通知发布</MButton
        >
        <MButton v-if="computedShowTONotice" type="primary" :simple="true" class="m-mr-16" @click="handlerGoLvzhi()"
          >会议通知取消/修改</MButton
        >
        <MButton type="primary" class="m-w-88" v-if="computedShowCancel" @click="handlerCancelReserve()"
          >取消预约</MButton
        >
      </div>
      <div class="footer m-fb-center-center" v-if="computedIsFooter">
        <MButton
          type="primary"
          :simple="true"
          class="m-mr-24"
          @click="handlerToApprove"
          v-if="uni == 'zheda' && appointmentDetail.auditStatus"
          >查看审批详情</MButton
        >
        <MButton
          type="primary"
          class="m-w-88"
          @click="handlerCancelReserve"
          v-if="CancelStatus.includes(appointmentDetail.status)"
          >取消预约</MButton
        >
      </div>
      <!-- 在审批中，或者超时，并且在我的节点上，才显示审批的同意拒绝 -->
      <div
        class="footer m-fb-center-center"
        v-if="
          +type === 3 &&
            [1, 5].includes(appointmentDetail.auditInfoDto.status) &&
            computedIsMe(appointmentDetail.auditInfoDto)
        "
      >
        <MButton type="primary" :simple="true" class="m-mr-16" @click="handlerDealAudit(0)">拒绝</MButton>
        <MButton type="primary" class="m-w-88" @click="handlerDealAudit(1)">同意</MButton>
      </div>
    </CommonBox>
  </div>
</template>

<script>
import { uni, uniShowSingleApproval } from 'CONFIG'
// import { commonDownload } from '@/utils/comUtils'
import { APPROVAL_AUDIT_MAP, SHOW_CANCEL_LIST } from '@/utils/constUtils'
import { timeFormatNew } from '@/utils/comUtils'
import { saveAs } from 'file-saver'
import status_1 from '@/assets/imgs/status/status_1.png'
import status_2 from '@/assets/imgs/status/status_2.png'
import status_3 from '@/assets/imgs/status/status_3.png'
import status_4 from '@/assets/imgs/status/status_4.png'
import status_5 from '@/assets/imgs/status/status_5.png'
import status_6 from '@/assets/imgs/status/status_6.png'

import meeting_status_0 from '@/assets/imgs/meeting/status_0.png'
import meeting_status_1 from '@/assets/imgs/meeting/status_1.png'
import meeting_status_2 from '@/assets/imgs/meeting/status_2.png'
import meeting_status_3 from '@/assets/imgs/meeting/status_3.png'
import meeting_status_4 from '@/assets/imgs/meeting/status_4.png'
import { web, approve } from '@/mixin'
import { mapGetters } from 'vuex'

export default {
  name: 'PageVenueAppointmentDetail',
  components: {},
  mixins: [web, approve],
  data() {
    let { reserveId, type } = this.$route.query || {}
    return {
      timeFormatNew,
      APPROVAL_AUDIT_MAP,
      SHOW_CANCEL_LIST,
      uni,
      uniShowSingleApproval,
      statusType: {
        0: status_1,
        1: status_1,
        2: status_2,
        3: status_6,
        4: status_4,
        5: status_5,
        6: status_6,
        7: status_6,
        8: status_6,
        9: status_3
      },
      meetingStatusType: {
        0: meeting_status_0,
        1: meeting_status_1,
        2: meeting_status_2,
        3: meeting_status_3,
        4: meeting_status_4
      },
      visible: false,
      isInitDoneFlag: false,
      type, //1 是我的预约，2：我收到的邀约
      reserveId, //预约的id
      spaceResourceId: '', //资源详情的id
      appointmentDetail: {}, // 档案详情
      resourceDetail: {}, //资源详情
      CancelStatus: [1, 4] //可以取消审批的状态，预约成功和待
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    // 浙大的是审批状态，其他的显示会议状态
    computedStatusType() {
      return this.uni == 'zheda' ? this.statusType : this.meetingStatusType
    },
    // 是否显示底部 我发起的预约，并且有审批或者可以取消审批
    computedIsFooter() {
      return this.type == 1 && this.uni == 'zheda' && this.CancelStatus.includes(this.appointmentDetail.status)
    },
    computedMemberName() {
      if (!this.appointmentDetail.participant && !this.appointmentDetail.participant.length) return ''
      let deptDtoList = this.appointmentDetail.participant.filter(it => it.type === 1)
      let memberDtoList = this.appointmentDetail.participant.filter(it => it.type === 2)
      return `${deptDtoList.map(it => it.name).join('、')}${
        deptDtoList.length && memberDtoList.length ? '、' : ''
      }${memberDtoList.map(it => it.name).join('、')}`
    },
    // 单节点审批展示取消预约按钮；未生效，未开始，进行中展示
    computedShowCancel() {
      const auditInfoDto = this.appointmentDetail.auditInfoDto
      return (
        this.uniShowSingleApproval &&
        (this.SHOW_CANCEL_LIST.includes(this.appointmentDetail.status) ||
          (+this.appointmentDetail.status === 0 && auditInfoDto && +auditInfoDto.status === 1)) &&
        +this.type === 1 &&
        this.appointmentDetail.oriStatus !== 9
      )
    },
    /**
     * 是否展示去智慧平台按钮：
     * 不需要审批的直接展示；
     * 需要审批的会议，需要在审批通过会议生效时再展示（未开始，进行中）；
     * 会议生效后取消（oriStatus为6）、生效后正常结束（oriStatus为5）均正常展示；
     */
    computedShowGolz() {
      return (
        this.uni === 'lvzhi' &&
        (!this.appointmentDetail.auditStatus ||
          (this.appointmentDetail.auditStatus &&
            ([1, 2].includes(this.appointmentDetail.status) || [5, 6].includes(this.appointmentDetail.oriStatus)))) &&
        [1, 2].includes(+this.type)
      )
    },
    /**
     * 是否展示去智慧平台按钮：
     * 不需要审批的直接展示；
     * 需要审批的会议，需要在审批通过会议生效时再展示（未开始，进行中）；
     * 会议生效后取消（oriStatus为6）、生效后正常结束（oriStatus为5）均不展示；
     * 我收到的邀约页不展示
     */
    computedShowTONotice() {
      return (
        this.uni === 'lvzhi' &&
        ((!this.appointmentDetail.auditStatus && [1, 2].includes(+this.appointmentDetail.status)) ||
          (this.appointmentDetail.auditStatus &&
            [1, 2].includes(+this.appointmentDetail.status) &&
            [5, 6].includes(+this.appointmentDetail.oriStatus) === false)) &&
        [1].includes(+this.type)
      )
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async init() {
      // 预约详情
      this.appointmentDetail = await this.fetchGetInitiatedReserveDetail()
      this.isInitDoneFlag = true
    },
    // 跳转旅职平台
    handlerGoLvzhi() {
      // window.open(`http://bgpt.tourzj.edu.cn:8093/zftal-zhbgpt-web?id=${this.reserveId}`)//之前“前往智慧办公平台”的按钮跳转地址
      window.open(
        `http://bgpt.tourzj.edu.cn:8093/zftal-zhbgpt-web/hygl/rcgl/zjZjlyRcgl.zf?layout=default&id=${this.reserveId}`
      )
    },
    // 查看审批
    handlerToApprove() {
      if (!this.appointmentDetail.formUrl) {
        this.$mmessage({
          type: 'warning',
          message: '未获取到审批详情'
        })
        return
      }
      window.open(this.appointmentDetail.formUrl, '_blank')
    },

    async handlerDownloadenClosure(item) {
      this.$httpGetStream(
        'apiCommonDownloadFile',
        {
          url: item.picUrl
        },
        { isShowError: false }
      )
        .then(res => {
          saveAs(res, item.fileName)
        })
        .catch(err => {
          console.log('err', err)
        })
    },
    // 去详情
    handlerToDetail() {
      this.$router.push({
        path: '/venue/list/detail',
        query: {
          spaceResourceId: this.appointmentDetail.resourceId,
          spaceArchivesId: this.appointmentDetail.spaceArchivesId
        }
      })
    },

    // 取消预约
    async handlerCancelReserve() {
      const _res = await this.fetchBreachRuleValidCancel()
      console.log(111, _res)
      let _btnIndex = await this.$mconfirm.warning({
        title: '取消预约', // 删除
        isShowHeadIcon: false,
        message: _res.flag
          ? '预约将被终止，并且会被记录一次违约，确认取消吗'
          : '预约将被终止并会发送通知给所有参与人，确认取消吗',
        buttons: [
          { name: '取消', type: 'primary', simple: true },
          { name: '确定', type: 'primary' }
        ]
      })
      if (_btnIndex === 1) {
        this.fetchspaceReserveCancel().then(() => {
          this.$mmessage({
            type: 'success',
            message: '取消成功'
          })
          this.init()
        })
      }
    },
    // 取消预约
    async handlerDealAudit(type) {
      if (type === 1) {
        this.fetchspaceReserveCancel(type).then(() => {
          this.$mmessage({
            type: 'success',
            message: '操作成功'
          })
          setTimeout(() => {
            this.init()
          }, 300)
        })
        return
      }
      let _btnIndex = await this.$mconfirm.warning({
        title: '审批拒绝', // 删除
        isShowHeadIcon: false,
        message: '确认拒绝当前的审批吗？',
        buttons: [
          { name: '取消', type: 'primary', simple: true },
          { name: '确定', type: 'primary' }
        ]
      })
      if (_btnIndex === 1) {
        this.fetchspaceReserveCancel(type).then(() => {
          this.$mmessage({
            type: 'success',
            message: '操作成功'
          })
          setTimeout(() => {
            this.init()
          }, 300)
        })
      }
    },
    //预约详情
    fetchGetInitiatedReserveDetail() {
      return this.$httpPost('apiInitiatedReserveDetail', { reserveId: this.reserveId })
    },
    /**
     * @description: 预校验取消预约是否违约
     * @return {*}
     */
    fetchBreachRuleValidCancel() {
      return this.$httpGet('breachRuleValidCancel', { reserveId: this.reserveId })
    },
    // 取消
    fetchspaceReserveCancel(auditResult) {
      let _postData = {
        reserveId: this.reserveId
      }
      if (+this.type === 3) {
        _postData.auditResult = auditResult
      }
      return this.$httpPost(+this.type === 3 ? 'apiDoAudit' : 'apiCancelReserve', _postData)
    },
    // 审批人是否是当前用户
    // type: 1 是审批 2是撤销审批人
    isMe(member, type = 1) {
      if (type === 1) {
        if ((member.startMemberId || member.memberId) === this.token.memberId) {
          return '我'
        } else {
          return member.startMemberName || member.memberName
        }
      } else {
        if (member.operMemberId === this.token.memberId) {
          return '我'
        } else {
          return member.operMemberName
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-box {
  position: relative;
  .status-img {
    width: 120px;
    height: 105px;
    position: absolute;
    right: 64px;
    top: 64px;
  }
  .line {
    width: 100%;
    height: 1px;
    background: #ededed;
  }
  .item {
    margin-bottom: 24px;
    display: flex;
    > span:first-child {
      width: 150px;
      text-align: right;
      color: #666666;
      margin-right: 16px;
      flex-shrink: 0;
    }
  }
}
.name {
  max-width: 210px;
}
.footer {
  height: 72px;
  box-shadow: 0px -2px 4px 0px rgba(51, 51, 51, 0.08);
}
</style>
